export const scripts = [
  "https://solinftec.github.io/wc-date-range/wc-date-range.min.js",
];
